import { createNewSessionIfNeeded } from '@src/quince-site-common/src/trackers/initializeAnalytics'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { getFromLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/getFromLocalStorageWithExpiry'
import { getlbUserId, createLastBrandUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import { setInLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/setInLocalStorageWithExpiry'
import { getCookie } from '@src/quince-site-integrated/src/utils'

export const validateLbUserId = () => {
  createLastBrandUserId() // Create if needed.
  const lbUserId = getlbUserId()
  if (lbUserId && !getFromLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, false)) {
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, lbUserId)
  }
  return lbUserId
}

let isNewSession = false

export const validateSessionId = () => {
  createNewSessionIfNeeded()
  const sessionId = getCookie(ANALYTIC_COOKIES.SESSION_ID)
  const sessionIdFromLocalStorage = getFromLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, true)
  if (sessionId && sessionIdFromLocalStorage !== sessionId) {
    isNewSession = true
  }
  if (sessionId) {
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, sessionId, 120)
  }
  return sessionId
}

export const executeOnceIfSessionIsNew = (task: () => void) => {
  if (isNewSession) {
    isNewSession = false
    try {
      task()
    } catch (error) {
      console.error('Error executing task for new session:', error)
    }
  }
}
